import React, { createContext, useContext, useState } from "react";

type ModalStackItem = { id: string };
type ModalContextType = {
  stack: ModalStackItem[];
  push: (id: string) => void;
  pop: (id: string) => void;
  isTop: (id: string) => boolean;
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [stack, setStack] = useState<ModalStackItem[]>([]);

  const push = (id: string) => setStack((s) => [...s, { id }]);
  const pop = (id: string) => setStack((s) => s.filter((item) => item.id !== id));
  const isTop = (id: string) => stack.length > 0 && stack[stack.length - 1].id === id;

  return (
    <ModalContext.Provider value={{ stack, push, pop, isTop }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModalStack() {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error("useModalStack must be used within ModalProvider");
  return ctx;
}